import React, { useEffect, useState } from "react";
import { Globe, FileText, Settings2, Bot } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import SeoOverview from "./SeoOverview";
import SeoContent from "./SeoContent";
import SeoSettings from "./SeoSettings";
import SeoCrawlers from "./SeoCrawlers";
import { api } from "../../api";

export default function SeoAdmin() {
  const [ov, setOv] = useState(null);
  const reload = () => api.seoOverview().then(({ data }) => setOv(data)).catch(() => setOv({}));
  useEffect(() => { reload(); }, []);
  return (
    <div data-testid="seo-admin">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
        <div><h1 className="font-display text-2xl md:text-3xl font-extrabold flex items-center gap-2"><Globe className="h-7 w-7 text-[#123C46]" /> SEO & AI Visibility</h1><p className="text-muted-foreground mt-1">Content Hub answer-first, dati strutturati, sitemap/robots/llms.txt, crawler AI, IndexNow e GA4/Ads.</p></div>
        {ov?.score !== undefined && <div className="rounded-2xl bg-white border border-border px-5 py-3 card-shadow text-center" data-testid="seo-score"><p className="font-display text-3xl font-extrabold text-[#123C46]">{ov.score}%</p><p className="text-[11px] uppercase tracking-wider text-muted-foreground font-bold">Readiness</p></div>}
      </div>
      <Tabs defaultValue="overview">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="overview" data-testid="seo-tab-overview" className="gap-1.5"><Globe className="h-4 w-4" /> Panoramica</TabsTrigger>
          <TabsTrigger value="content" data-testid="seo-tab-content" className="gap-1.5"><FileText className="h-4 w-4" /> Contenuti</TabsTrigger>
          <TabsTrigger value="crawlers" data-testid="seo-tab-crawlers" className="gap-1.5"><Bot className="h-4 w-4" /> Crawler AI</TabsTrigger>
          <TabsTrigger value="settings" data-testid="seo-tab-settings" className="gap-1.5"><Settings2 className="h-4 w-4" /> Impostazioni</TabsTrigger>
        </TabsList>
        <TabsContent value="overview"><SeoOverview ov={ov} reload={reload} /></TabsContent>
        <TabsContent value="content"><SeoContent onChange={reload} /></TabsContent>
        <TabsContent value="crawlers"><SeoCrawlers ov={ov} /></TabsContent>
        <TabsContent value="settings"><SeoSettings onSaved={reload} knownBots={ov?.known_bots || []} /></TabsContent>
      </Tabs>
    </div>
  );
}
